import { api, ApiError } from "./api";

export interface CreditsInfo {
  plan: "free" | "starter" | "pro" | "studio";
  quota: number;
  used: number;
  remaining: number;
  period_start: number;
  resets_at: number;
}

export interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string | null;
    created_at: number;
    email_verified_at: number | null;
    logo_url: string | null;
    x_user_id?: string | null;
    x_username?: string | null;
    x_avatar_url?: string | null;
    x_name?: string | null;
    email_is_placeholder?: boolean;
  };
  subscription: { plan: string; status: string };
  credits: CreditsInfo;
}

export async function fetchMe(): Promise<MeResponse | null> {
  try {
    return await api.get<MeResponse>("/api/me");
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}

export async function logout(): Promise<void> {
  await api.post("/api/auth/logout");
}

export interface AuthResponse {
  ok: boolean;
  user: { id: string; email: string };
}

export async function signup(email: string, password: string): Promise<AuthResponse> {
  return api.post<AuthResponse>("/api/auth/signup", { email, password });
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  return api.post<AuthResponse>("/api/auth/login", { email, password });
}
